// firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyA7xsm6yqjFvgU1JQ_N0UFEEgKd42CwQt4",
    authDomain: "mukneon-brotopia.firebaseapp.com",
    projectId: "mukneon-brotopia",
    storageBucket: "mukneon-brotopia.firebasestorage.app",
    messagingSenderId: "67371022930",
    appId: "1:67371022930:web:5c40eb4816e5e51b8cfd8b"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);